import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';


export interface ILoaderModel {
  visible: boolean;
  title: string;
  description: string;
}


export class Loader {
  static readonly type: string = '[Loader] Set Loader Status Visible';
  constructor(public visible: boolean, public title?: string, public description?: string) { }
}

@State<ILoaderModel>({
  name: 'loaderState',
  defaults: {
    visible: false,
    title: '',
    description: ''
  }
})
@Injectable()
export class LoaderState {
  constructor() { }
  @Selector()
  static getLoaderStatus(state: ILoaderModel): ILoaderModel {
    return {
      visible: state.visible,
      title: state.title,
      description: state.description
    };
  }

  @Action(Loader)
  Loader(ctx: StateContext<ILoaderModel>, action: Loader): void {
    ctx.patchState({
      visible: action.visible,
      title: action.visible ? action.title : null,
      description: action.visible ? action.description : null
    });
  }
}
